export default {
    setCompanies(state, data) {
        state.companies = data
    },
    setStatuses(state, data) {
        state.statuses = data
    },
    setCompany(state, data) {
        state.company = data
    },
    patchCompany(state, { id, active }) {
        if (state.company && state.company.id === id) {
            state.company = { ...state.company, active }
        }
        if (state.companies && Array.isArray(state.companies.data)) {
            state.companies.data = state.companies.data.map((c) =>
                c.id === id ? { ...c, active } : c
            )
        }
    },
    setCompanyStats(state, data) {
        state.companyStats = data
    },
    setCompanySettings(state, data) {
        state.companySettings = data
    },
    setCompanyHeaderMail(state, data) {
        state.companyHeaderMail = data
    },
    setCompaniesFilters(state, data) {
        state.companiesFilters = data
    },
    setNewCompany(state, data) {
        state.newCompany = data
    },
    setTemplates(state, data) {
        state.templates = data
    },
    deleteTemplate(state, data) {
        let newTemplates = []
        state.templates.forEach((template) => {
            if (template !== data) {
                newTemplates.push(template)
            }
        })
        state.templates = newTemplates
    },
    setTemplatesFilters(state, data) {
        state.templatesFilters = data
    },
    addTemplate(state, data) {
        state.templates.push(data)
    },
    setTemplate(state, data) {
        state.template = data
    },
    editTemplate(state, data) {
        state.template = data
        state.templates[data.id - 1] = data
    },
    setPagination(state, data) {
        state.pagination = data
    },
    setImpersonation(state, data) {
        state.isUnderImpersonation = true
        state.userImpersonated = data.user
    },
    leaveImpersonation(state) {
        state.isUnderImpersonation = false
        state.userImpersonated = null
    }
}
